module.exports = __webpack_public_path__ + "img/发展历程W.1919aa65.svg";